/**
 * KOSH mark — Wisewit's AI copilot glyph.
 *
 * Original SVG design (not sourced from any icon library):
 * - Outer form: an angular vessel/ingot silhouette (a "kosha" — Sanskrit for
 *   treasury/sheath). Pointed apex + trapezoid body = industrial + precious.
 * - Inner glyph: a bold "K" formed by two sharp strokes, in electric lime —
 *   the letter reads at 14px and stays crisp at 96px.
 * - Nucleus dot at the K's junction — the "spark of intelligence".
 * - Bottom notch: a slot/gap suggesting a signal port / plug-in surface.
 *
 * Rendered on a transparent background so it composes cleanly against the
 * orange FAB (white outline) OR the glass panel header (color outline).
 */
export default function KoshMark({ size = 22, tone = "on-color" }) {
  // tone="on-color"  -> for orange FAB (white strokes + lime accent)
  // tone="on-glass"  -> for panel header (orange + lime + cyan on transparent)
  const isColor = tone === "on-color";
  const outer = isColor ? "#FFFFFF" : "#FF4500";
  const kColor = isColor ? "#FFFFFF" : "#DFFF00";
  const spark = isColor ? "#DFFF00" : "#00E5FF";
  const sw = isColor ? 2 : 1.75;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="KOSH"
      data-testid="kosh-mark"
    >
      {/* Angular vessel — pointed apex, sloped shoulders, wide chest, notched base */}
      <path
        d="M16 2 L27 8 L27 22 L20 30 L12 30 L5 22 L5 8 Z"
        stroke={outer}
        strokeWidth={sw}
        strokeLinejoin="miter"
        fill="none"
      />
      {/* Inner K — vertical shaft + two angular kicks */}
      <path
        d="M12 10 L12 24"
        stroke={kColor}
        strokeWidth={sw + 0.5}
        strokeLinecap="butt"
      />
      <path
        d="M12 17 L20 10"
        stroke={kColor}
        strokeWidth={sw + 0.5}
        strokeLinecap="butt"
      />
      <path
        d="M12 17 L20 24"
        stroke={kColor}
        strokeWidth={sw + 0.5}
        strokeLinecap="butt"
      />
      {/* Spark nucleus at the K's junction */}
      <circle cx="12" cy="17" r="1.6" fill={spark} />
      {/* Base slot — signal port */}
      <path
        d="M14 30 L18 30"
        stroke={spark}
        strokeWidth={sw}
        strokeLinecap="square"
      />
    </svg>
  );
}
